import React from 'react';
import { motion } from 'framer-motion';

const FAQSection = ({ language }) => {
  const isZh = language === 'zh';
  const faqs = isZh
    ? [
        {
          q: '為什麼要記錄寵物紀念日？',
          a: '記錄紀念日能幫助主人建立與寵物的情感聯繫，並能作為寵物成長與健康管理的重要參考。透過天數計算，您可以精準規劃疫苗接種、健康檢查或慶祝活動。'
        },
        {
          q: '如何計算最準確的寵物年齡？',
          a: '本工具提供「生日」計算模式，輸入出生日期後，系統會詳細列出年、月、日，並自動標註重要的成長里程碑，如百日、週年等。'
        },
        {
          q: '支持哪些類型的寵物？',
          a: '我們支持狗狗、貓咪、鳥類、兔子、倉鼠、魚、烏龜等多種常見寵物，並提供對應的語義化圖示與分享卡片。'
        }
      ]
    : [
        {
          q: 'Why track pet anniversaries?',
          a: 'Tracking anniversaries strengthens the bond between owners and pets. It serves as a visual timeline for growth and health management, helping you plan vet visits and celebrations.'
        },
        {
          q: 'How do I calculate a precise pet age?',
          a: 'Use our Birthday mode. Enter the birth date to see a detailed breakdown of years, months, and days, along with unlocked milestones.'
        }
      ];

  return (
    <section className="mt-8 bg-white dark:bg-gray-850 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-gray-800">
      <h2 className="text-xl font-bold mb-6 text-gray-800 dark:text-gray-200 flex items-center">
        <span className="mr-2">💡</span>
        {isZh ? '如何記錄寵物的重要日子與成長？' : 'How can you track important pet dates and growth?'}
      </h2>
      <div className="space-y-6">
        {faqs.map((faq, index) => (
          <motion.article
            key={faq.q}
            className="border-b border-gray-50 dark:border-gray-800 pb-4 last:border-0"
            initial={{ opacity: 0, y: 8 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.06 }}
          >
            <h3 className="font-semibold text-love-600 dark:text-love-400 mb-2">
              {faq.q}
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
              {faq.a}
            </p>
          </motion.article>
        ))}
      </div>
      <div className="mt-4 text-xs text-gray-400 dark:text-gray-500 text-right">
        {isZh ? '更新日期：' : 'Updated: '}
        <time dateTime="2026-03-04">
          {isZh ? '2026年3月4日' : 'March 4, 2026'}
        </time>
      </div>
    </section>
  );
};

export default FAQSection;